'use es6';

export const NAVIGATE = 'NAVIGATE';